// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-xlight":"#fcfcfc","row":"ygAJLY6 _2wW_gNj","block":"otD-rb5 undefined","liner":"_1a_Z7Yn"};